import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { ScanLine } from 'lucide-react';
import { url } from '../../utils/confserveur';
import SessionLive from './SessionLive';
import { lireJetonFragment, messageRefus } from './jetonScan';

/**
 * Page PUBLIQUE du téléphone relié par le QR projeté (`/scan/:id#<jeton>`).
 *
 * Hors espace connecté : pas de compte, pas de GAR, pas de barre latérale. Le
 * jeton est lu dans le fragment, retiré de la barre d'adresse, puis réclamé au
 * serveur (`reclamer-scan`), qui pose le cookie de séance. Ensuite la page rend
 * le pilotage existant en mode jeton, nourri par le flux SSE seul.
 *
 * Sans fragment (rechargement du téléphone, retour sur l'onglet), on tente le
 * pilotage directement : le cookie est encore là tant que la séance vit. S'il
 * ne l'est plus, le serveur refuse et l'écran dit de rescanner.
 */

const EcranScan = ({ titre, texte, attente = false }) => (
    <div
        className="fixed inset-0 flex flex-col items-center justify-center gap-4 px-8 text-center text-white"
        style={{ background: '#0e1116' }}
    >
        <ScanLine size={40} style={{ color: attente ? '#a9e8c9' : '#f5c26b' }} className={attente ? 'animate-pulse' : ''} />
        <h1 className="font-black text-2xl" style={{ fontFamily: "'Archivo', 'Inter', system-ui, sans-serif" }}>
            {titre}
        </h1>
        {texte ? <p className="text-sm leading-relaxed max-w-sm" style={{ color: '#aab3a8' }}>{texte}</p> : null}
    </div>
);

const EntreeScan = () => {
    const { id } = useParams();
    // 'reclamation' → 'pilotage', ou 'refus' { code, statut }.
    const [etat, setEtat] = useState(() => (
        lireJetonFragment(window.location.hash) ? { phase: 'reclamation' } : { phase: 'pilotage' }
    ));

    useEffect(() => {
        if (etat.phase !== 'reclamation') return undefined;
        const jeton = lireJetonFragment(window.location.hash);
        // Le jeton quitte la barre d'adresse tout de suite : ni historique, ni
        // partage par mégarde d'une adresse qui vaut encore deux minutes.
        window.history.replaceState(null, '', window.location.pathname);
        let annule = false;
        axios.post(`${url}sessions-qcm/${id}/reclamer-scan/`, { jeton }, { withCredentials: true })
            .then(() => { if (!annule) setEtat({ phase: 'pilotage' }); })
            .catch((err) => {
                if (annule) return;
                setEtat({ phase: 'refus', code: err?.response?.data?.error, statut: err?.response?.status });
            });
        return () => { annule = true; };
    }, [etat.phase, id]);

    if (etat.phase === 'reclamation') {
        return <EcranScan titre="Connexion à la séance…" attente />;
    }
    if (etat.phase === 'refus') {
        return <EcranScan {...messageRefus(etat.code, etat.statut)} />;
    }
    return (
        <SessionLive
            sessionId={id}
            modeJeton
            onPerdu={(code) => setEtat({ phase: 'refus', code: typeof code === 'string' ? code : 'detache' })}
        />
    );
};

export default EntreeScan;
